export enum GsapClassNames {
  StartPart = 'start-part',
  TitlePart = 'title-part',
  Independent = 'independent',
  Dependent = 'dependent',
  PageNumber = 'page-number',
  TextBlock = 'text-block',
  Quote = 'quote',
  Pinned = 'pinned',
  Illustration = 'illustration',
  Drawable = 'drawable',
}

const IS_NEED_ANIMATE = '(prefers-reduced-motion: no-preference)';

export const MATCH_MEDIA_CONDITIONS = {
  isLg: `(min-width: 1024px) and (max-width: 1599px) and ${IS_NEED_ANIMATE}`,
  isDesktop: `(min-width: 1600px) and ${IS_NEED_ANIMATE}`,
};
